import React, {Component} from 'react'
import {connect} from 'react-redux'
import {actions} from 'react-redux-form'
import {Link} from 'react-router-dom'
import {Grid, Button} from 'react-bootstrap'
import ProductsList from "./products-list";
import ProductSearchComponent from '../../../../common/search/simple-search-component'
import PageTitle from "../../../../common/page-title/index";
import ArrowButton from "../../../../common/button-arrow";
import {getProducts} from '../../../../../actions/products'

import '../../common/styles.css'

class Products extends Component {
  constructor(props) {
    super(props);

    this.state = {
      query: ''
    }
  }

  componentWillMount() {
    // this.props.dispatch(actions.reset('deep.admin_product_save'));
    this.props.dispatch({type: 'CLEAR_EDIT_PRODUCT'});
    this.props.dispatch(getProducts());
  }

  handleInputChange = (e) => {
    this.setState({query: e.target.value});
  };

  handleSearch = () => {
    const {query} = this.state;
    this.props.dispatch(getProducts(query));
  };

  handleClear = () => {
    this.setState({query: '',}, this.handleSearch);
  };

  render() {
    return (
      <Grid bsClass="container" fluid className="products accordion">
        <PageTitle>Products</PageTitle>
        <Link to="/admin/products/new">
          <ArrowButton color="red"
                       className="add-product"
                       submit={false}
                       arrow={false}
                       permissions={{
                         action: 'new',
                         subjectClass: 'Product'
                       }}>Add product</ArrowButton>
        </Link>

        <ProductSearchComponent searchValue={this.state.query}
                                onInputChange={this.handleInputChange}
                                onSearch={this.handleSearch}
                                onClear={this.handleClear}/>
        <ProductsList products={this.props.products}
                      fetching={this.props.fetching}
                      fetched={this.props.fetched}
        />
      </Grid>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    products: state.products.products,
    fetched:  state.products.fetched,
    fetching: state.products.fetching,
  };
};

export default connect(mapStateToProps)(Products);


// WEBPACK FOOTER //
// ./src/components/admin/products/products/list/index.jsx